import React, { useState } from "react";
import { IconClose } from "../../../components/Ui/Icon";
import LoadingOverlay from "../../../components/Ui/LoadingOverlay";

import { toast } from "react-toastify";

import { COUPON_STATUS } from "../../../constants/index";
import { adminCreateCoupon, adminUpdateCoupon } from "../../../services/coupon";
import { formatDate, generateCouponCode } from "../../../utils/utils";

const Create = ({ togglePopup, onSubmited, data }) => {
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState(
    data
      ? data
      : {
          code: "",
          maxUse: 1,
          startDate: "",
          expiredDate: "",
          sermons: 1,
          status: "active",
        }
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue((preValue) => ({
      ...preValue,
      [`${name}`]: value,
    }));
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    const callAPI = async () => {
      setLoading(true);
      try {
        if (!data || !data._id) {
          await adminCreateCoupon(formValue);
        } else {
          await adminUpdateCoupon(data._id, formValue);
        }

        setTimeout(() => {
          setLoading(false);
        });
        toast.success("Successfully");
        togglePopup();
        onSubmited();
      } catch (error) {
        console.log("error", error);
        toast.error(error?.response?.data?.message);
        setLoading(false);
      }
    };
    callAPI();
  };

  const generatePassword = () => {
    const code = generateCouponCode(6);
    setFormValue((preValue) => ({
      ...preValue,
      code: code,
    }));
  };

  return (
    <div>
      {loading && <LoadingOverlay />}
      <div className="modal flex overflow-y-auto overflow-x-hidden fixed inset-0 bg-gray-700 bg-opacity-75 z-[6] justify-center items-center w-full max-h-full">
        <div
          className="relative p-4 w-full max-w-4xl max-h-full"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
            <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
              <h3 className="text-xl font-semibold text-black dark:text-white">
                {data ? "Update" : "Create"}
              </h3>
              <button
                type="button"
                className="z-[7] text-gray-400 bg-transparent hover:bg-gray-200 hover:text-black rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                onClick={togglePopup}
              >
                <IconClose />
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            <div className="p-4 md:p-5 space-y-4">
              <div className="flex flex-col md:flex-row w-full">
                <div className="w-full p-4 overflow-x-auto shadow-md shadow-slate-300">
                  <form
                    onSubmit={(e) => onSubmitHandler(e)}
                    className="grid gap-4 sm:grid-cols-2 sm:gap-6 [&_input]:outline-none [&_textarea]:outline-none"
                  >
                    <div className="sm:col-span-1">
                      <label
                        htmlFor="code"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Code
                      </label>
                      <div className="relative w-full">
                        <input
                          type="text"
                          name="code"
                          value={formValue.code}
                          onChange={handleChange}
                          required
                          className="block outline-none p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-lg border focus:ring-blue-500 focus:border-blue-500"
                          placeholder="Coupon Code"
                        />

                        <button
                          type="button"
                          onClick={generatePassword}
                          className="absolute top-0 end-0 p-2.5 text-sm font-medium h-full text-white bg-slate-400 rounded-e-lg border border-slate-300 hover:bg-slate-500 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        >
                          <span>Generate</span>
                        </button>
                      </div>
                    </div>

                    <div className="sm:col-span-1">
                      <label
                        htmlFor="sermons"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Sermons
                      </label>
                      <input
                        type="number"
                        name="sermons"
                        value={formValue.sermons}
                        onChange={handleChange}
                        placeholder="Sort"
                        required
                        className="shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </div>
                    <div className="sm:col-span-1">
                      <label
                        htmlFor="maxUse"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Number of uses:
                      </label>
                      <input
                        type="number"
                        name="maxUse"
                        value={formValue.maxUse}
                        onChange={handleChange}
                        placeholder="max uses"
                        required
                        className="shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </div>
                    <div className="sm:col-span-1">
                      <label
                        htmlFor="startDate"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Start Date
                      </label>
                      <input
                        type="date"
                        name="startDate"
                        value={
                          formValue.startDate
                            ? formatDate(new Date(formValue.startDate))
                            : formValue.startDate
                        }
                        onChange={handleChange}
                        required={true}
                        min={formatDate()}
                        className="shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </div>
                    <div className="sm:col-span-1">
                      <label
                        htmlFor="expiredDate"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Expired Date
                      </label>
                      <input
                        type="date"
                        name="expiredDate"
                        value={
                          formValue.expiredDate
                            ? formatDate(new Date(formValue.expiredDate))
                            : formValue.expiredDate
                        }
                        onChange={handleChange}
                        required={true}
                        min={formatDate()}
                        className="shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </div>

                    {data && (
                      <div className="sm:col-span-1">
                        <label
                          htmlFor="status"
                          className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                        >
                          Status:
                        </label>
                        <select
                          className="cursor-not-allowed shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="status"
                          defaultValue={formValue.status}
                          onChange={(e) =>
                            setFormValue((preValue) => ({
                              ...preValue,
                              status: e.target.value,
                            }))
                          }
                          disabled={false}
                        >
                          {Object.values(COUPON_STATUS).map((u) => (
                            <option value={u} key={u}>
                              {u}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    <div className="flex justify-center sm:col-span-2">
                      <button
                        disabled={loading}
                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;
